import { Api } from "../axios-config";
import { CapitalizationDocumentType } from "./types";

const uploadCapitalizationDocument = async (
    capitalizationId: string,
    file: File,
    description: string
): Promise<any> => {
    const formData = new FormData();
    formData.append("capitalizationId", capitalizationId);
    formData.append("file", file);
    formData.append("description", description);
    const { data } = await Api().post("/capitalization-documents", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    return data as any;
};

const getCapitalizationDocuments = async (
    capitalizationId: string
): Promise<CapitalizationDocumentType[]> => {
    const { data } = await Api().get(
        `/capitalization-documents/capitalization/${capitalizationId}`
    );

    return data as CapitalizationDocumentType[];
};

const removeDocumentByCapitalization = async (
    documentId: string
): Promise<void | Error> => {

    try {
        const { data } = await Api().patch(
            `/capitalization-documents/${documentId}`
        );

        if (!data)
            return new Promise((_, reject) =>
                reject(new Error("Erro ao remover documento."))
            );
    } catch (error: any) {
        console.error(error);
        return new Promise((_, reject) => reject(error));
    }
};

const previewCapitalizationDocument = async (documentId: string, mimeType: string): Promise<Blob | Error> => {
    try {
        const { data } = await Api().get(`/capitalization-documents/${documentId}/base64`);

        // Handle potential response structures (plain string or object)
        const base64 = typeof data === 'string' ? data : (data.base64 || data.data || "");

        if (!base64) throw new Error("Conteúdo do arquivo vazio ou inválido");

        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        return blob;
    } catch (error: any) {
        return new Error(error?.message || "Erro ao carregar o documento");
    }
};

export const CapitalizationDocumentsService = {
    uploadCapitalizationDocument,
    getCapitalizationDocuments,
    removeDocumentByCapitalization,
    previewCapitalizationDocument,
};
